<template>
    <section class="relative overflow-hidden bg-green-950 py-10 md:py-10">
        <NuxtImg
            class="absolute left-0 top-0 h-full w-full object-cover opacity-50"
            src="/assets/images/sliders/slider-04.webp"
            :alt="config.public.company.name" />

        <UContainer class="relative z-10">
            <UPageHero
                title="100% Fully Managed Plantation Ownership"
                description="An Opportunity that offers 19.31% Annualized Returns"
                :links="[
                    {
                        label: 'ROI Calculator',
                        icon: 'i-bi-calculator',
                        color: 'blue',
                        variant: 'solid',
                        size: 'xl',
                        leading: true,
                        block: false,
                        click: () => isModalOpenInvestorCalculator()
                    },
                    {
                        to: '/agarwood-plantation-ownership',
                        label: 'Claim Your FREE Guide',
                        icon: 'i-bi-arrow-right',
                        color: 'green',
                        variant: 'solid',
                        size: 'xl',
                        trailing: true,
                        block: false
                    }
                ]"
                align="center" />
        </UContainer>
    </section>

    <ModalsInvestorCalculator v-model="modalOpenInvestorCalculator" />
</template>

<script setup>
    const config = useRuntimeConfig()

    const modalOpenInvestorCalculator = ref(false)

    const isModalOpenInvestorCalculator = () => {
        modalOpenInvestorCalculator.value = true
    }

    provide('investor-calculator-modal', {
        modalOpenInvestorCalculator
    })
</script>
